import * as React from "react";
import { ScenarioType } from "../../Types";

export interface Props {
  ownership: ScenarioType["ownership"];
  dollarsPerkWh: number;
}

/**
 * How a scenario is scored, in the player's terms. Shared by the scenario details screen and the
 * custom game screen, which both offer it behind an info button.
 *
 * Scoring algorithm should also be updated in Game.tsx and in the Manual.
 */
export default function VictoryConditions(props: Props): React.JSX.Element {
  const { ownership, dollarsPerkWh } = props;
  if (ownership === "Investor") {
    return (
      <div>
        <p>+40 pts per $1B of net worth at the end</p>
        <p>+2 pts per 100k customers at the end</p>
        <p>+1 pt per TWh of electricity supplied</p>
        <p>-2 pts per megaton (1M tons) of greenhouse gas emissions</p>
        <p>-8 pts per TWh of blackouts</p>
      </div>
    );
  }
  return (
    <div>
      <p>
        +/-80 pts per lifetime average $0.01/kWh charged above/below $
        {dollarsPerkWh}/kWh
      </p>
      <p>+10 pts per TWh of electricity supplied</p>
      <p>-5 pts per megaton (1M tons) of greenhouse gas emissions</p>
      <p>-10 pts per TWh of blackouts</p>
    </div>
  );
}
